import { gridWidth } from '@zimpel/common/components/Grid';
import styled from 'styled-components';

export const HeaderWrapper = styled.header`
  flex: 0 0 var(--app-header-height);
  width: 100%;
  height: var(--app-header-height);
  border-bottom: var(--border-box);
  background-color: var(--color-header-background);
  color: var(--color-text-bright);
  position: sticky;
  top: 0;
  z-index: var(--z-index-app-header);
`;

export const HeaderCentered = styled.div`
  display: flex;
  align-items: center;
  width: ${gridWidth};
  height: var(--app-header-height);
  margin: auto;
`;
